module.exports = __webpack_public_path__ + "img/hongbao.eb920f4a.png";